import useRecycleMaterials from "./useRecycleMaterials";

import { BusinessRole } from "../types/domain";

/**
 *
 * @param {BusinessRole} businessRole
 *
 * @deprecated use useRecycleMaterials instead
 */
const useTires = (businessRole?: BusinessRole) => {
  return useRecycleMaterials(businessRole ? [businessRole] : undefined);
};

export default useTires;
